<div class="community-reactions" *transloco="let t" role="group" [attr.aria-label]="t('community.reactions.label')">
  @for (key of keys; track key) {
    <button type="button"
            class="community-reactions__btn"
            [class.community-reactions__btn--mine]="mine().has(key)"
            [class.community-reactions__btn--active]="count(key) > 0"
            [disabled]="!canReact || busy() !== null || !inSet(key)"
            [attr.aria-pressed]="mine().has(key)"
            [title]="canReact ? t('community.reactions.react_with', { name: t('community.reactions.names.' + key) }) : t('community.reactions.not_allowed')"
            (click)="toggle(key)">
      <span class="community-reactions__emoji" aria-hidden="true">{{ emoji(key) }}</span>
      @if (count(key) > 0) {
        <span class="community-reactions__count">{{ count(key) }}</span>
      }
    </button>
  }
</div>
